import {Divider, Result, Spin} from "antd";
import React, {useContext, useEffect, useState} from "react";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import AuthContext from "../utilis/contexts/AuthContext";
import AppContext from "../utilis/contexts/AppContext";
import InfiniteScroll from "react-infinite-scroll-component";

import {FrownOutlined} from "@ant-design/icons";
import BillCard from "../components/BillCard";
import LocalStorage from "../utilis/tools/LocalStorage";
import localStorage from "../utilis/tools/LocalStorage";
import ReactApexChart from "react-apexcharts";
import PaymentCard from "../components/PaymentCard";
const PaymentHistory = () => {
    const authContext = useContext(AuthContext)
    const appContext = useContext(AppContext)
    const Token=LocalStorage.getToken();
    const [payments, setPayments] = useState<Array<object>>([]);

    const [state, setState] = useState<any>({
        items: [],
        hasMore: false
    })
    useEffect(() => {
        if (payments.length) {
            setState({
                items: payments.slice(0, 10),
                hasMore: payments.length > 10
            })
        }
    }, [payments])
    const fetchMoreData = () => {
        if (!state.hasMore) {
            return;
        }
        
        setTimeout(() => {
            setState({
                items: state.items.concat(payments.slice(state.items.length, state.items.length + 10 > payments.length ? payments.length : state.items.length + 10)),
                hasMore: state.items.length + 10 < payments.length
            });
        }, 1000);
    };

    useEffect(() => {

        if (Token) {
            appContext.handleLoading(true)

            Api.post(Urls.GetPaymentHistory, {
                Cellphone: authContext.user.cellphone,
                BillId: LocalStorage.getBranchInfo().bill_id,
                FileNumber:LocalStorage.getFileNumber(),
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {
                const {data} = response;
                const {Data} = data;
                const {payments} = Data;
                setPayments(payments)
            }).catch((e: AxiosError) => {

            }).finally(() => {
                appContext.handleLoading(false)
            })
        }
    }, [])
    return <>

        <Divider><h3 className="font-bold ">لیست پرداخت‌ها</h3></Divider>
        {payments.length>0 &&   <InfiniteScroll
            dataLength={state.items.length}
            next={fetchMoreData} className="overflow-auto min-h-[500px]"
            hasMore={state.hasMore}
            loader={<div className="flex w-full mb-3 justify-center"><Spin/></div>}

        >
            {state.items.map((item: any, index: number) => (
                <PaymentCard item={item} key={'payment-item-'+index} />
            ))}
        </InfiniteScroll>}
        {!payments.length && !appContext.isLoading && <Result
            icon={<FrownOutlined />}
            subTitle="هیچ پرداختی یافت نشد."

        />}

    </>
}
export default PaymentHistory;